import { Modal } from 'components/atoms/Modal';
import { IconClose } from 'components/atoms/icons/IconClose';
import { SelectField } from 'components/molecules/SelectField';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { TSelectTruckModal } from 'types/Collect';
import { TModal } from 'types/modal';
import { SelectOption } from '../EditCompressionsResourceDataModal';
import styles from './CollectEmissionsSelectDriverModal.module.scss';
import { useEffect, useState } from 'react';
import { getCollectRouteDetail } from 'apis/collect_route';
import { getUsers } from 'apis/operator_site/siteApi';
import { RoleType } from 'util/Enums';
import { isRouteIdExist } from 'util/collectingRoute';

type TruckModalProps = TModal & {
  closeModal: () => void;
  onSubmit: (driverId: string) => void;
  routeId: string | undefined;
};

const CollectEmissionsSelectDriverModal = ({
  closeModal,
  onSubmit,
  routeId,
}: TruckModalProps) => {
  const { t } = useTranslation();
  const [driverOptions, setDriverOptions] = useState<SelectOption[]>([]);

  const fetchRouteDetail = async () => {
    await getCollectRouteDetail({
      id: Number(routeId),
      successCallback: (data) => {
        setDriverOptions(
          data.drivers.map(({ id, name }) => ({
            label: name,
            value: id,
          }))
        );
      },
    });
  };

  const fetchUsers = async () => {
    await getUsers({
      params: {
        take: Number.MAX_SAFE_INTEGER,
      },
      successCallback: (data) => {
        setDriverOptions(
          data.users
            .filter((u) => u.type === RoleType.UserNormal)
            .map(({ id, name }) => ({
              label: name,
              value: id,
            }))
        );
      },
    });
  };

  useEffect(() => {
    if (isRouteIdExist(routeId)) {
      fetchRouteDetail();
    } else {
      fetchUsers();
    }
  }, [routeId]);

  return (
    <section className={styles['truck-modal']}>
      <Modal>
        <div className={styles['customTitle']}>
          <div className={styles['title']}>
            {t('collect_registration.driver_modal.title')}
          </div>
          <div className={styles['top']} onClick={closeModal}>
            <IconClose />
          </div>
        </div>
        <div className={styles['form-body']}>
          <Form<TSelectTruckModal>
            onSubmit={(value: TSelectTruckModal) => onSubmit(value.driverId)}
            render={({ handleSubmit, invalid }) => (
              <form onSubmit={handleSubmit} className={styles['form-body']}>
                <div className={styles['selectBox']}>
                  <SelectField
                    name="driverId"
                    options={driverOptions}
                    label={t('collect_registration.driver_modal.driver')}
                    placeholder={t('collect_registration.driver_modal.driver')}
                    isDarkmode
                    searchable
                  />
                </div>
                <div className={styles['submit']}>
                  <button
                    className={styles['submitButton']}
                    type="submit"
                    disabled={invalid}
                  >
                    {t('common.button.next')}
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      </Modal>
    </section>
  );
};

export default CollectEmissionsSelectDriverModal;
